// extracted by mini-css-extract-plugin
export var content = "IEqBXcEPP2kiauRCsi5n";
export var info = "YLP6mITdAfzkwkXSQjMP";
export var link = "DOkT6BvfLum5iLHCeV9U";
export var negative = "kKFruwV9R36yRGXmA2CD";
export var neutral = "yIQo2pOgxRrk1T2o9pWX";
export var positive = "DpZEadUvDXvissgL6ytx";
export var primary = "aQh0YLYL2146TO2nX8rm";
export var root = "pNICRTdvQCbwyhTWdTsg";
export var secondary = "xUnX6i1YmioWPg1ipmKQ";
export var sideItem = "_PRpnj1myPzwY5tqCrmA";
export var warning = "LvH3uwU5dVR9jw2j0l3F";